import axios from 'axios'
import License from '../models/License'

class DriverService {
  listCaselessOperations () {
    return axios.get('/driver-api/caseless-operations').then(({ data }) => {
      return data.map((operation) => {
        return {
          value: operation.id,
          label: operation.name,
          logo: operation.logo
        }
      })
    })
  }

  caselessSearch (operationId, license, state) {
    return axios
      .post('/driver-api/caseless-operations/license-citations', {
        operation_id: operationId,
        license_number: license,
        license_state: state
      })
      .then(({ data }) => License.fromJson(data.data))
  }

  caselessBill (operationId, licenseNumber, licenseState, citations) {
    return axios
      .post('/driver-api/caseless-operations/license-bill', {
        operation_id: operationId,
        license_number: licenseNumber,
        license_state: licenseState,
        citations
      })
      .then(({ data }) => data)
  }

  checkoutCC (
    firstName,
    lastName,
    addressLine,
    addressLine2,
    city,
    state,
    zipCode,
    country,
    phone,
    email,
    licenseNumber,
    licenseState,
    citationsIds,
    operationId,
    paymentMethodToken,
    recaptchaToken
  ) {
    return axios
      .post('/driver-api/caseless-operations/checkout', {
        firstname: firstName,
        lastname: lastName,
        recaptcha_token: recaptchaToken,
        billing_address: {
          country,
          state,
          city,
          postalcode: zipCode,
          street: addressLine,
          street2: addressLine2
        },
        phone,
        email,
        terms: true,
        license_number: licenseNumber,
        license_state: licenseState,
        citations: citationsIds,
        operation_id: operationId,
        payment_method_token: paymentMethodToken,
      })
      .then()
  }

  fetchFAQ (operationId) {
    return axios
      .get(`/driver-api/caseless-operations/frequently-asked-questions?operation_id=${operationId}`)
      .then(({ data }) => data?.faq)
  }
}

export default DriverService
